export const therapyProcess = {
  title: 'Come funziona il percorso terapeutico',
  sections: [
    {
      id: 'typical-results',
      title: 'Risultati tipici',
      content: 'I miei pazienti riportano miglioramenti significativi entro i primi 6 mesi di terapia, con una riduzione significativa dei sintomi iniziali. Il percorso medio dura 12-18 mesi, permettendo di costruire cambiamenti duraturi e strategie efficaci per il lungo termine.',
      includeReviews: true,
      cta: {
        text: 'Scopri come posso aiutarti',
        action: 'discover-help'
      },
      metadata: {
        order: 1,
        section: 'process'
      }
    },
    {
      id: 'assessment',
      title: 'Il primo mese: Assessment Completo',
      type: 'list',
      items: [
        'Valutazione approfondita della situazione attuale',
        'Somministrazione di test scientificamente validati (PID-5 e Young Schema Questionnaire, altri test specifici se necessari)',
        'Comprensione delle tue esigenze specifiche e dei tuoi obiettivi'
      ],
      metadata: {
        order: 2,
        section: 'process'
      }
    },
    {
      id: 'analysis-planning',
      title: 'Analisi e Pianificazione',
      type: 'list',
      items: [
        'Elaborazione dei risultati dei test',
        'Identificazione delle aree di intervento prioritarie',
        'Definizione degli obiettivi terapeutici'
      ],
      metadata: {
        order: 3,
        section: 'process'
      }
    },
    {
      id: 'personalized-path',
      title: 'Il Tuo Percorso Personalizzato',
      type: 'list',
      items: [
        'Creazione di un piano terapeutico su misura',
        'Integrazione di tecniche CBT specifiche per le tue esigenze',
        'Monitoraggio costante dei progressi'
      ],
      metadata: {
        order: 4,
        section: 'process'
      }
    },
    {
      id: 'assessment-importance',
      title: 'Perché l\'Assessment è importante',
      content: 'L\'utilizzo di test psicodiagnostici validati scientificamente permette di:',
      type: 'list',
      items: [
        'Ottenere una valutazione oggettiva della situazione iniziale',
        'Identificare pattern comportamentali e schemi di pensiero',
        'Creare un percorso terapeutico basato su dati concreti',
        'Misurare i progressi in modo tangibile durante la terapia'
      ],
      metadata: {
        order: 5,
        section: 'process'
      }
    },
    {
      id: 'cbt-methodology',
      title: 'La Terapia Cognitivo-Comportamentale (CBT)',
      subtitle: 'risultati concreti, scientificamente provati',
      type: 'multi-list',
      lists: [
        {
          items: [
            'Riduci ansia e stress con tecniche pratiche e personalizzate',
            'Acquisisci strumenti efficaci per gestire le tue emozioni',
            'Raggiungi obiettivi misurabili in tempi definiti',
            'Beneficia di un metodo supportato da oltre 50 anni di ricerca scientifica'
          ]
        },
        {
          subtitle: 'La CBT ti aiuta a:',
          items: [
            'Identificare e modificare pensieri disfunzionali',
            'Sviluppare strategie di coping efficaci',
            'Migliorare le tue relazioni personali e professionali',
            'Costruire una maggiore resilienza emotiva'
          ]
        }
      ],
      metadata: {
        order: 6,
        section: 'methodology'
      }
    },
    {
      id: 'rfd-integration',
      title: 'Innovazione Scientifica',
      type: 'paragraphs',
      paragraphs: [
        'La Relational Fractal Dimension è un innovativo metodo scientifico che migliora l\'efficacia della terapia, permettendoti di vedere progressi concreti e misurabili nel tuo percorso di crescita personale.',
        'Unisco l\'efficacia comprovata della CBT con l\'innovativo metodo RFD, permettendo di monitorare scientificamente i progressi della terapia e ottimizzare il percorso di guarigione.'
      ],
      metadata: {
        order: 7,
        section: 'innovation'
      }
    }
  ]
};